import { BaseBus } from "./BaseBus";

export class InvoiceCheckListBus extends BaseBus
{
    invoiceCheckListId: any;
    customerInvoiceCheckListId: any;
    invoiceId: any;
    note: string;
    readOnly: boolean;
    isChecked: boolean;
    isCheckedOriginalValue: boolean;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    sortOrder: number;
    states: any;
    get isChanged() : boolean {
        return this.isChecked !== this.isCheckedOriginalValue;
    }
    set isChanged(value: boolean) {

    }
    setUpdated() {
        this.isUpdated = this.isChanged;
    }
}
